<!-- 货币头部行情 -->
<template>
  <div class="currency-market-box row">
    <!-- 7日年化 -->
    <div class="currency-item" @click="goHistoryNetDetail">
      <div class="currency-rate row" :style="{ color: getRateColor(basicInfo.historyNetValue)}">
        <div class="currency-7d">{{basicInfo.historyNetValue}}</div>
        <div class="currency-7d-unit">%</div>
      </div>
      <div class="desc">7日年化</div>
    </div>
    <!-- 万元收益 -->
    <div class="currency-item">
      <div class="currency-7d">{{basicInfo.netValue}}</div>
      <div class="desc">{{`万元收益 ${netValueDate}`}}</div>
    </div>
  </div>
</template>

<script>
import tool from '@/utils/tool';

export default {
  name: 'currency-market-header',

  props: {
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    netValueDate() {
      return this.$isEmpty(this.basicInfo?.netValueDate) ? '--'
        : this.basicInfo?.netValueDate.replace(/(\d{4})-(\d{2})-(\d{2})/, '$2-$3');
    },
  },

  methods: {
    getRateColor: tool.getRateColor,
    goHistoryNetDetail() {
      tool.goDetail(`fund://mp.1234567.com.cn/weex/516939c37bdb4ba2b1138c50cf69a2e1/pages/FundHistoryIncome?fundCode=${this.basicInfo?.fundCode}&fundName=${this.basicInfo?.fundName}&featuretype=${this.basicInfo?.feature}`, this.$goFundApp);
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
}
.currency-market-box {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 0 13px;
  justify-content: left;
  align-items: flex-end;
}
.currency-item {
  flex: 1;
  .currency-rate {
    justify-content: left;
    align-items: baseline;
  }
  .currency-7d {
    font-family: DINAlternate-Bold;
    font-size: 72px;
    line-height: 72px;
  }
  .currency-7d-unit {
    font-family: DINAlternate-Bold;
    font-size: 36px;
    line-height: 36px;
  }
  .desc {
    font-size: 26px;
    color: #999999;
  }
}
</style>
